// extracted by mini-css-extract-plugin
export default {"dropdown":"TableManageRequestsActions_dropdown__xYQ7a"};